<template>
	<div>
        <b-modal ref="saveModal" :ok-title="$t('misc.ok')" :cancel-title="$t('misc.cancel')" :title="actionTitle" size="lg" @ok="saveAction" @hidden="hidden" :ok-disabled="this.$store.state.ajax_in_progress">
            <div class="row">
                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4 mt-1">
                            <label>{{ $t('table.company') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="model.selectedCompany"
                                :options="currentCompany"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isLoadingCompany"
                                :preserve-search="true"
                                placeholder=""
                                label="name" track-by="id"
                                :selectLabel="''"
                                @search-change="onCompanySearch"
                                @input="updateCompany"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="model.selectedCompany != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedCompany"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6" v-if="model.selectedCompany != null">
                    <div class="row mb-3">
                        <div class="col-lg-4 mt-1">
                            <label>{{ $t('table.price_type') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <select class="form-control" v-model="model.type" @change="clearSearches" :disabled="isDuplicate">
                                <option v-for="price_type in price_types_clone" :value="price_type.code">{{price_type.name}}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row" v-if="model.type != null">
                <div class="col-lg-12" v-if="model.selectedCompany != null">
                    <div class="row mb-2">
                        <div class="col-lg-2 mt-1">
                            <label>{{ $t('table.price_type_id') }}</label>
                        </div>
                        <div class="col-lg-10">
                            <multiselect v-model="model.selectedPriceTypeId"
                                :options="currentPriceTypeId"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isLoadingPriceTypeId"
                                :preserve-search="true"
                                placeholder=""
                                label="price_type_id" track-by="price_type_id"
                                :selectLabel="''"
                                @search-change="onPriceTypeSearchId"
                                @input="updatePriceTypeId"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="model.selectedPriceTypeId != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedPriceTypeId"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>
                </div>

                <div class="col-lg-12" v-if="model.selectedCompany != null">
                    <div class="row mb-2">
                        <div class="col-lg-2 mt-1">
                            <label>{{ $t('table.list_id') }}</label>
                        </div>
                        <div class="col-lg-10">
                            <multiselect v-model="model.selectedListId"
                                :options="currentListId"
                                :multiple="false"
                                :clear-on-select="false"
                                :hide-selected="false"
                                :loading="isLoadingListId"
                                :preserve-search="false"
                                placeholder=""
                                label="info" track-by="id"
                                :selectLabel="''"
                                @input="updateListId"
                                :disabled="isDuplicate"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="model.selectedListId != null && !isDuplicate" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedListId"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>
                </div>
            </div>

            <hr v-if="model.type != null && model.company_id != null">

            <div class="row" v-if="(model.type == 'part' && model.company_id != null) || model.type == 'custom'">
                <div class="col-lg-6">
                    <div class="row mb-3" v-if="(model.type == 'part' && model.company_id != null) || model.type == 'custom'">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_number') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.part_number" :disabled="isDuplicate">
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.type == 'part' && model.company_id != null">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_standard') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <select class="form-control" v-model="model.part_standard" :disabled="isDuplicate">
                                <option v-for="(value,key) in part_standards" :value="key" :key="key">{{value}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="(model.type == 'part' && model.company_id != null) || model.type == 'custom'">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_description') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea type="text" rows="5" maxlength="255" class="form-control" v-model="model.part_description" :disabled="isDuplicate"></textarea>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.type == 'part' && model.company_id != null">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_material') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.part_material" :disabled="isDuplicate">
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="row mb-3" v-if="model.type == 'part' && model.company_id != null">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_size') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.part_size" :disabled="isDuplicate">
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.type == 'part' && model.company_id != null">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_thk') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.part_thk" :disabled="isDuplicate">
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.type == 'part' && model.company_id != null">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_sizer') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.part_sizer" :disabled="isDuplicate">
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.type == 'part' && model.company_id != null">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_thkr') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.part_thkr" :disabled="isDuplicate">
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.type == 'part' && model.company_id != null">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_dimension') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.part_dimension" :disabled="isDuplicate">
                        </div>
                    </div>
                </div>
            </div>

            <div class="row" v-if="model.type == 'weld' && model.company_id != null">
                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.weld_place') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <select class="form-control" v-model="model.weld_place" :disabled="isDuplicate">
                                <option v-for="weld_place in weld_places" :value="weld_place.name" :key="weld_place.name">{{weld_place.name}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.weld_type') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="model.selectedProjectSetting"
                                :options="currentProjectSetting"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isProjectSettingLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="value" track-by="id"
                                :selectLabel="''"
                                @search-change="onProjectSettingSearch"
                                @input="updateProjectSetting"
                                :disabled="isDuplicate"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="model.selectedProjectSetting != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedProjectSetting"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.weld_size') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.weld_size" :disabled="isDuplicate">
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.weld_dimension') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.weld_dimension" :disabled="isDuplicate">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.weld_standard') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <select class="form-control" v-model="model.weld_standard" :disabled="isDuplicate">
                                <option v-for="(value,key) in part_standards" :value="key" :key="key">{{value}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.weld_material') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="model.selectedWeldMaterial"
                                :options="currentWeldMaterial"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isWeldMaterialLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="value" track-by="id"
                                :selectLabel="''"
                                @search-change="onWeldMaterialSearch"
                                @input="updateWeldMaterial"
                                :disabled="isDuplicate"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="model.selectedWeldMaterial != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedWeldMaterial"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row" v-if="model.type == 'equipment' && model.company_id != null">
                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.equipment') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.equipment" :disabled="isDuplicate">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.equipment_item_no') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" class="form-control" v-model="model.equipment_item_no" :disabled="isDuplicate">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.equipment_description') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea rows="6" maxlength="5000" class="form-control" v-model="model.equipment_description" :disabled="isDuplicate"></textarea>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_idmm') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.part_data_id" :disabled="isDuplicate">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_hlmm') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.part_data_hl" :disabled="isDuplicate">
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_insulmm') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.part_data_insul" :disabled="isDuplicate">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.elevation') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.elevation" :disabled="isDuplicate">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.remark_1') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea class="form-control" maxlength="255" rows="4" v-model="model.remarks1"></textarea>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.remark_2') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea class="form-control" maxlength="255" rows="4" v-model="model.remarks2"></textarea>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row" v-if="model.type == 'painting' && model.company_id != null">
                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_painting_no') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.part_painting_no" :disabled="isDuplicate">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_painting_description') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea rows="6" maxlength="5000" class="form-control" v-model="model.part_painting_description" :disabled="isDuplicate"></textarea>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_painting_code') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.part_painting_code" :disabled="isDuplicate">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_painting_thickness') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.part_painting_thickness" :disabled="isDuplicate">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_painting_color') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.part_painting_color" :disabled="isDuplicate">
                        </div>
                    </div>
                </div>
            </div>

            <div class="row" v-if="model.type == 'scaffolding' && model.company_id != null">
                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.scaffolding_part_no') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.scaffolding_part_no" :disabled="isDuplicate">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.scaffolding_part_description') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea rows="6" maxlength="5000" class="form-control" v-model="model.scaffolding_part_description" :disabled="isDuplicate"></textarea>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.elevation') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.elevation">
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.scaffolding_part_length') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.scaffolding_part_length" :disabled="isDuplicate">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.scaffolding_part_width') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.scaffolding_part_width" :disabled="isDuplicate">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.scaffolding_part_height') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.scaffolding_part_height" :disabled="isDuplicate">
                        </div>
                    </div>
                </div>
            </div>

            <div class="row" v-if="model.type == 'insulation' && model.company_id != null">
                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_insulation_no') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.part_insulation_no" :disabled="isDuplicate">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_insulation_description') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea rows="6" maxlength="5000" class="form-control" v-model="model.part_insulation_description" :disabled="isDuplicate"></textarea>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_insulation_type') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.part_insulation_type" :disabled="isDuplicate">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_insulation_thickness') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.part_insulation_thickness" :disabled="isDuplicate">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.part_insulation_code') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.part_insulation_code" :disabled="isDuplicate">
                        </div>
                    </div>
                </div>
            </div>

            <div class="row" v-if="model.type == 'tie_in' && model.company_id != null">
                <div class="col-lg-12">
                    <div class="row mb-3">
                        <div class="col-lg-12">
                            <label>{{ $t('table.tie_in_description') }}</label>
                        </div>
                        <div class="col-lg-12">
                            <textarea rows="6" maxlength="5000" class="form-control" v-model="model.tie_in_description" :disabled="isDuplicate"></textarea>
                        </div>
                    </div>
                </div>
            </div>

            <hr v-if="model.selectedCompany != null">

            <div class="row" v-if="model.selectedCompany != null">
                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.quantity') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==6) return false;" step=".01" class="form-control" v-model="model.quantity">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.measureunit') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <select class="form-control" v-model="model.measureunit" :disabled="isDuplicate">
                                <option v-for="measure_unit in measure_units" :value="measure_unit.code" :key="measure_unit.code">{{ measure_unit.name }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.unitweight') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.unitweight">
                        </div>
                    </div>
                </div>

                <div class="col-lg-6" v-if="model.type != 'equipment' && model.type != 'scaffolding' && model.type != 'insulation'">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.remarks') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea rows="6" maxlength="5000" class="form-control" v-model="model.remarks1"></textarea>
                        </div>
                    </div>
                </div>
            </div>

            <hr v-if="model.selectedCompany != null && this.$store.getters.hasPermission(['project_prices'])">

            <div class="row" v-if="model.selectedCompany != null && this.$store.getters.hasPermission(['project_prices'])">
                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.work_price') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.subcontractor_work_price" :disabled="true">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.material_price') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.subcontractor_material_price" :disabled="true">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.other_price') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.subcontractor_other_price" :disabled="true">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.currency') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <select v-model="model.subcontractor_currency" class="form-control" size="1" :disabled="true">
                                <option v-for="currency in currencies" :value="currency.code">{{ currency.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="row mb-3" v-if="model.type != 'equipment'">
                        <div class="col-lg-4">
                            <label>{{ $t('table.notes') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea maxlength="255" class="form-control" rows="8" v-model="model.note"></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
	</div>
</template>

<script>
import Vue from 'vue';
import http from '@/libs/http';
import Multiselect from 'vue-multiselect';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import * as notificationIcons from '@/components/global/miscellaneous/notificationIcons.js';
import miniToastr from 'mini-toastr';

export default {
	name: 'CalculationModal',
	components: {
		flatPickr,
		notificationIcons,
		Multiselect
	},
	props: {
        currentListId: {
			type: Array,
            default: function () {
                return [];
            }
		},
        actionTitle: {
			type: String,
			default: ''
		},
        addType: {
			type: String,
			default: ''
		},
		model: {
			type: Object,
			default: () => ({
                id: null,
                company_id: null,
                note: null,
                type: null,
                type_id: null,
                list_id: null,
                quantity: null,
                subcontractor_material_price: null,
                subcontractor_work_price: null,
                subcontractor_other_price: null,
                currency: null,

                part_number: null,
                part_description: null,
                part_material: null,
                part_size: null,
                part_sizer: null,
                part_thk: null,
                part_thkr: null,
                part_standard: null,
                part_dimension: null,
                weld_type_id: null,
                weld_place: null,
                weld_size: null,
                weld_dimension: null,
                weld_standard: null,
                weld_material_id: null,
                equipment: null,
                equipment_item_no: null,
                equipment_description: null,
                part_data_id: null,
                part_data_hl: null,
                part_data_insul: null,
                part_painting_no: null,
                part_painting_description: null,
                part_painting_code: null,
                part_painting_thickness: null,
                part_painting_color: null,
                scaffolding_part_no: null,
                scaffolding_part_description: null,
                scaffolding_part_length: null,
                scaffolding_part_width: null,
                scaffolding_part_height: null,
                part_insulation_no: null,
                part_insulation_description: null,
                part_insulation_type: null,
                part_insulation_thickness: null,
                part_insulation_code: null,
                tie_in_description: null,
                elevation: null,
                measureunit: null,
                unitweight: null,
                remarks1: null,
                remarks2: null,
                percent_finished: null,
			})
		}
	},
	data() {
		return {
            isDuplicate: false,
            price_types_clone: {},

            currentCompany: [],
            isLoadingCompany: false,

            currentPriceTypeId: [],
            isLoadingPriceTypeId: false,

            // currentListId: [],
            isLoadingListId: false,

            currentProjectSetting: [],
            isProjectSettingLoading: false,

            currentWeldMaterial: [],
            isWeldMaterialLoading: false,
		}
	},
	computed: {
        measure_units: {
			get: function () {
				let measure_units = this.$store.getters.getMeasureUnits;
				return measure_units;
			}
		},
        currencies: {
            get: function () {
                let currencies = this.$store.getters.getCurrencies;
                return currencies;
            }
        },
        price_types: {
            get: function () {
                let price_types = this.$store.getters.getPriceTypes;
                return price_types;
            }
        },
        calculation_types: {
            get: function () {
                let calculation_types = this.$store.getters.getCalculationTypes;
                return calculation_types;
            }
        },
        weld_places: {
			get: function () {
                let weld_places = this.$store.getters.getWeldPlaces;
				return weld_places;
			}
		},
        part_standards: {
            get: function () {
                let standard = this.$store.getters.getPartStandard;
                return standard;
            }
        }
    },
	methods: {
        successMsg(msg) {
			miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
		},
		errorMsg(msg) {
			miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
		},
		saveAction (e) {
            e.preventDefault();
            var vm = this;

            let put_data = {
                project_id:     this.$route.params.id,
                company_id:     this.model.company_id,
                type:           this.model.type,
                section:        this.addType,
                // type_id:        this.model.type_id,
                list_id:        this.model.list_id,
                quantity:       this.model.quantity,
                // material_price: this.model.subcontractor_material_price,
                // work_price:     this.model.subcontractor_work_price,
                // other_price:    this.model.subcontractor_other_price,
                // currency:       this.model.subcontractor_currency,
                note:           this.model.note,
            };

            put_data['part_number']                  = this.model.part_number;
            put_data['part_description']             = this.model.part_description;
            put_data['part_material']                = this.model.part_material;
            put_data['part_size']                    = this.model.part_size;
            put_data['part_sizer']                   = this.model.part_sizer;
            put_data['part_thk']                     = this.model.part_thk;
            put_data['part_thkr']                    = this.model.part_thkr;
            put_data['part_standard']                = this.model.part_standard;
            put_data['part_dimension']               = this.model.part_dimension;
            put_data['weld_type_id']                 = this.model.weld_type_id;
            put_data['weld_place']                   = this.model.weld_place;
            put_data['weld_size']                    = this.model.weld_size;
            put_data['weld_dimension']               = this.model.weld_dimension;
            put_data['weld_standard']                = this.model.weld_standard;
            put_data['weld_material_id']             = this.model.weld_material_id;
            put_data['equipment']                    = this.model.equipment;
            put_data['equipment_item_no']            = this.model.equipment_item_no;
            put_data['equipment_description']        = this.model.equipment_description;
            put_data['part_data_id']                 = this.model.part_data_id;
            put_data['part_data_hl']                 = this.model.part_data_hl;
            put_data['part_data_insul']              = this.model.part_data_insul;
            put_data['part_painting_no']             = this.model.part_painting_no;
            put_data['part_painting_description']    = this.model.part_painting_description;
            put_data['part_painting_code']           = this.model.part_painting_code;
            put_data['part_painting_thickness']      = this.model.part_painting_thickness;
            put_data['part_painting_color']          = this.model.part_painting_color;
            put_data['scaffolding_part_no']          = this.model.scaffolding_part_no;
            put_data['scaffolding_part_description'] = this.model.scaffolding_part_description;
            put_data['scaffolding_part_length']      = this.model.scaffolding_part_length;
            put_data['scaffolding_part_width']       = this.model.scaffolding_part_width;
            put_data['scaffolding_part_height']      = this.model.scaffolding_part_height;
            put_data['part_insulation_no']           = this.model.part_insulation_no;
            put_data['part_insulation_description']  = this.model.part_insulation_description;
            put_data['part_insulation_type']         = this.model.part_insulation_type;
            put_data['part_insulation_thickness']    = this.model.part_insulation_thickness;
            put_data['part_insulation_code']         = this.model.part_insulation_code;
            put_data['tie_in_description']           = this.model.tie_in_description;
            put_data['elevation']                    = this.model.elevation;
            put_data['measureunit']                  = this.model.measureunit;
            put_data['unitweight']                   = this.model.unitweight;
            put_data['remarks1']                     = this.model.remarks1;
            put_data['remarks2']                     = this.model.remarks2;
            put_data['percent_finished']             = this.model.percent_finished;

            Object.keys(put_data).forEach(key => {
                if (put_data[key] === '') {
                    put_data[key] = null;
                }
            });

            if (this.row && this.row.id) {
                let data = http.route('project_calculation/' + this.row.id).patch(put_data, true);
                data.then(response => {
                    if (response.isError == false) {
                        this.$emit('onLoadTable');
                        this.successMsg(Vue.i18n.translate('table.calculation') + ' ' + Vue.i18n.translate('messages.updated'));
                        this.$refs.saveModal.hide();
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                });
            } else {
                if (this.isDuplicate) {
                    put_data['is_duplicate'] = 1;
                }

                let data = http.route('project_calculation').post(put_data, true);
                data.then(response => {
                    if (response.isError == false) {
                        this.$emit('onLoadTable');
                        this.successMsg(Vue.i18n.translate('table.calculation') + ' ' + Vue.i18n.translate('messages.created'));
                        this.$refs.saveModal.hide();
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                });
            }
        },
        show() {
            switch(this.addType) {
                case 'piping':
                    this.price_types_clone['part']   = this.price_types.part;
                    this.price_types_clone['weld']   = this.price_types.weld;
                    this.price_types_clone['custom'] = this.price_types.custom;
                break;
                case 'equipment':
                    this.price_types_clone['equipment'] = this.price_types.equipment;
                    this.price_types_clone['custom']    = this.price_types.custom;
                break;
                case 'painting':
                    this.price_types_clone['painting'] = this.price_types.painting;
                    this.price_types_clone['custom']   = this.price_types.custom;
                break;
                case 'scaffolding':
                    this.price_types_clone['scaffolding'] = this.price_types.scaffolding;
                    this.price_types_clone['custom']      = this.price_types.custom;
                break;
                case 'insulation':
                    this.price_types_clone['insulation'] = this.price_types.insulation;
                    this.price_types_clone['custom']     = this.price_types.custom;
                break;
                case 'steel':
                    this.price_types_clone['part']   = this.price_types.part;
                    this.price_types_clone['custom'] = this.price_types.custom;
                break;
                case 'civil':
                    this.price_types_clone['part']   = this.price_types.part;
                    this.price_types_clone['custom'] = this.price_types.custom;
                break;
                case 'ei':
                    this.price_types_clone['part']   = this.price_types.part;
                    this.price_types_clone['custom'] = this.price_types.custom;
                break;
                case 'other':
                    this.price_types_clone['part']   = this.price_types.part;
                    this.price_types_clone['custom'] = this.price_types.custom;
                break;
                case 'tie_in':
                    this.price_types_clone['tie_in'] = this.price_types.tie_in;
                    this.price_types_clone['custom'] = this.price_types.custom;
                break;
                case 'change_order':
                    this.price_types_clone['part']   = this.price_types.part;
                    this.price_types_clone['weld']   = this.price_types.weld;
                    this.price_types_clone['equipment'] = this.price_types.equipment;
                    this.price_types_clone['painting'] = this.price_types.painting;
                    this.price_types_clone['scaffolding'] = this.price_types.scaffolding;
                    this.price_types_clone['insulation'] = this.price_types.insulation;
                    this.price_types_clone['tie_in'] = this.price_types.tie_in;
                    this.price_types_clone['custom'] = this.price_types.custom;
                break;
            }

			this.$refs.saveModal.show();
		},
        hidden(e) {
            this.$emit('hidden');
            this.clearSearches(e, true);
        },
        clearSearches(e, all = false) {
            this.model.id                           = null;
            this.model.type_id                      = null;
            if (all) {
                this.model.list_id                      = null;
            }
            this.model.quantity                     = null;
            this.model.subcontractor_material_price = null;
            this.model.subcontractor_work_price     = null;
            this.model.subcontractor_other_price    = null;
            this.model.subcontractor_currency       = null;

            this.model.selectedProjectSetting       = null;
            this.model.selectedWeldMaterial         = null;
            this.currentProjectSetting              = [];
            this.currentWeldMaterial                = [];
            this.model.part_number                  = null;
            this.model.part_description             = null;
            this.model.part_material                = null;
            this.model.part_size                    = null;
            this.model.part_thk                     = null;
            this.model.part_sizer                   = null;
            this.model.part_thkr                    = null;
            this.model.part_standard                = null;
            this.model.part_dimension               = null;
            this.model.weld_type_id                 = null;
            this.model.weld_place                   = null;
            this.model.weld_size                    = null;
            this.model.weld_dimension               = null;
            this.model.weld_standard                = null;
            this.model.weld_material_id             = null;
            this.model.equipment                    = null;
            this.model.equipment_item_no            = null;
            this.model.equipment_description        = null;
            this.model.part_data_id                 = null;
            this.model.part_data_hl                 = null;
            this.model.part_data_insul              = null;
            this.model.part_painting_no             = null;
            this.model.part_painting_description    = null;
            this.model.part_painting_code           = null;
            this.model.part_painting_thickness      = null;
            this.model.part_painting_color          = null;
            this.model.scaffolding_part_no          = null;
            this.model.scaffolding_part_description = null;
            this.model.scaffolding_part_length      = null;
            this.model.scaffolding_part_width       = null;
            this.model.scaffolding_part_height      = null;
            this.model.part_insulation_no           = null;
            this.model.part_insulation_description  = null;
            this.model.part_insulation_type         = null;
            this.model.part_insulation_thickness    = null;
            this.model.part_insulation_code         = null;
            this.model.tie_in_description           = null;
            this.model.elevation                    = null;
            this.model.measureunit                  = null;
            this.model.unitweight                   = null;
            this.model.remarks1                     = null;
            this.model.remarks2                     = null;
            this.model.percent_finished             = null;
            this.model.note                         = null;
            this.model.selectedPriceTypeId          = null;
            this.currentCompany                     = [];
            this.currentPriceTypeId                 = [];
            if (all) {
                this.model.selectedListId               = null;
                // this.currentListId                      = [];
            }
        },
        onCompanySearch(search) {
            if (search == '') {
                this.currentCompany = [];
                
                return false;
            }

            this.isLoadingCompany = true;
            this.search(search, this);
        },
        search: _.debounce((search, vm) => {
            let data = http.route('company?get_all=1&search_select=' + search + '&subcontractors=1&project_id=' + vm.$route.params.id).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentCompany = response.data;
                }
                vm.isLoadingCompany = false;
            });
        }, 500),
        updateCompany(company) {
            if (this.model.company_id != 0) {
                this.model.type_id = null;
                this.model.selectedPriceTypeId = null;
                this.currentPriceTypeId = [];
                if (this.model.type == null) {
                    this.model.list_id = null;
                }
            }

            this.model.company_id = (company != null) ? company.id : null;
        },
        clearSelectedCompany () {
            this.model.selectedCompany = null;
            this.model.company_id      = null;
        },
        onPriceTypeSearchId(search) {
            if (search == '') {
                this.currentPriceTypeId = [];
                
                return false;
            }

            this.currentPriceTypeId = [];
            this.isLoadingPriceTypeId = true;
            this.searchPriceTypeId(search, this);
        },
        searchPriceTypeId: _.debounce((search, vm) => {
            http.route('project_' + vm.model.type + '_price_list?get_all=1&company_id=' + vm.model.company_id + '&project_id=' + vm.$route.params.id + '&search_select=' + search + '&from_calculation=1').get().then(response => {
                if (response.data != false) {
                    vm.currentPriceTypeId = response.data;
                }
                vm.isLoadingPriceTypeId = false;
            });
        }, 500),
        updatePriceTypeId(priceid) {
            if (priceid == null) {
                this.model.type_id                      = null;
                this.model.measureunit                  = null;
                this.model.subcontractor_material_price = null;
                this.model.subcontractor_work_price     = null;
                this.model.subcontractor_other_price    = null;
                this.model.subcontractor_currency       = null;
            } else {
                this.model.id                           = priceid.id;
                this.model.company_id                   = priceid.company_id;
                this.model.quantity                     = priceid.quantity;
                this.model.subcontractor_material_price = priceid.material_price;
                this.model.subcontractor_work_price     = priceid.work_price;
                this.model.subcontractor_other_price    = priceid.other_price;
                this.model.subcontractor_currency       = priceid.currency;

                this.model.part_number                  = priceid.part_number;
                this.model.part_description             = priceid.part_description;
                this.model.part_material                = priceid.part_material;
                this.model.part_size                    = priceid.part_size;
                this.model.part_sizer                   = priceid.part_sizer;
                this.model.part_thk                     = priceid.part_thk;
                this.model.part_thkr                    = priceid.part_thkr;
                this.model.part_standard                = priceid.part_standard;
                this.model.part_dimension               = priceid.part_dimension;
                this.model.weld_type_id                 = priceid.weld_type_id;
                this.model.weld_place                   = priceid.weld_place;
                this.model.weld_size                    = priceid.weld_size;
                this.model.weld_dimension               = priceid.weld_dimension;
                this.model.weld_standard                = priceid.weld_standard;
                this.model.weld_material_id             = priceid.weld_material_id;
                this.model.equipment                    = priceid.equipment;
                this.model.equipment_item_no            = priceid.equipment_item_no;
                this.model.equipment_description        = priceid.equipment_description;
                this.model.part_data_id                 = priceid.part_data_id;
                this.model.part_data_hl                 = priceid.part_data_hl;
                this.model.part_data_insul              = priceid.part_data_insul;
                this.model.part_painting_no             = priceid.part_painting_no;
                this.model.part_painting_description    = priceid.part_painting_description;
                this.model.part_painting_code           = priceid.part_painting_code;
                this.model.part_painting_thickness      = priceid.part_painting_thickness;
                this.model.part_painting_color          = priceid.part_painting_color;
                this.model.scaffolding_part_no          = priceid.scaffolding_part_no;
                this.model.scaffolding_part_description = priceid.scaffolding_part_description;
                this.model.scaffolding_part_length      = priceid.scaffolding_part_length;
                this.model.scaffolding_part_width       = priceid.scaffolding_part_width;
                this.model.scaffolding_part_height      = priceid.scaffolding_part_height;
                this.model.part_insulation_no           = priceid.part_insulation_no;
                this.model.part_insulation_description  = priceid.part_insulation_description;
                this.model.part_insulation_type         = priceid.part_insulation_type;
                this.model.part_insulation_thickness    = priceid.part_insulation_thickness;
                this.model.part_insulation_code         = priceid.part_insulation_code;
                this.model.tie_in_description           = priceid.tie_in_description;
                this.model.elevation                    = priceid.elevation;
                this.model.measureunit                  = priceid.measureunit;
                this.model.unitweight                   = priceid.unitweight;
                this.model.remarks1                     = priceid.remarks1;
                this.model.remarks2                     = priceid.remarks2;
                this.model.percent_finished             = priceid.percent_finished;
                this.model.selectedProjectSetting       = priceid.project_setting;
                this.model.selectedWeldMaterial         = priceid.weld_material;
            }
        },
        clearSelectedPriceTypeId () {
            this.model.selectedPriceTypeId = null;
        },
        // onListIdSearch(search) {
        //     if (search == '') {
        //         this.currentListId = [];
                
        //         return false;
        //     }

        //     this.currentListId = [];
        //     this.isLoadingListId = true;
        //     this.searchListId(search, this);
        // },
        // searchListId: _.debounce((search, vm) => {
        //     var data = null;
        //     switch(vm.addType) {
        //         case 'piping':
        //             data = http.route('drawing?get_all=1&filters[discipline_id]=1&project_id='+vm.$route.params.id+'&search_select=' + search + '&filters[parent_drawing_id]=null').get();
        //             break;
        //         case 'steel':
        //             data = http.route('drawing?get_all=1&filters[discipline_id]=2&project_id='+vm.$route.params.id+'&search_select=' + search + '&filters[parent_drawing_id]=null').get();
        //             break;
        //         case 'equipment':
        //             data = http.route('drawing?get_all=1&filters[discipline_id]=3&project_id='+vm.$route.params.id+'&search_select=' + search + '&filters[parent_drawing_id]=null').get();
        //             break;
        //         case 'civil':
        //             data = http.route('drawing?get_all=1&filters[discipline_id]=4&project_id='+vm.$route.params.id+'&search_select=' + search + '&filters[parent_drawing_id]=null').get();
        //             break;
        //         case 'ei':
        //             data = http.route('drawing?get_all=1&filters[discipline_id]=5&project_id='+vm.$route.params.id+'&search_select=' + search + '&filters[parent_drawing_id]=null').get();
        //             break;
        //         case 'other':
        //             data = http.route('drawing?get_all=1&filters[discipline_id]=6&project_id='+vm.$route.params.id+'&search_select=' + search + '&filters[parent_drawing_id]=null').get();
        //             break;
        //         case 'painting':
        //             data = http.route('drawing?get_all=1&project_id='+vm.$route.params.id+'&search_select=' + search + '&filters[show_painting]=1').get();
        //             break;
        //         case 'insulation':
        //             data = http.route('drawing?get_all=1&project_id='+vm.$route.params.id+'&search_select=' + search + '&filters[show_insulation]=1').get();
        //             break;
        //         case 'tie_in':
        //             data = http.route('tie_in?get_all=1&project_id='+vm.$route.params.id+'&search_select=' + search + '&filters[parent_tie_in_id]=null').get();
        //             break;
        //         case 'scaffolding':
        //             data = http.route('scaffolding?get_all=1&project_id='+vm.$route.params.id+'&search_select=' + search).get();
        //             break;
        //         case 'change_order':
        //             data = http.route('change_order?get_all=1&project_id='+vm.$route.params.id+'&search_select=' + search + '&filters[parent_change_order_id]=null').get();
        //             break;
        //     }
        //     data.then(response => {
        //         if (response.data != false) {
        //             vm.currentListId = response.data;
        //         }
        //         vm.isLoadingListId = false;
        //     });
        // }, 500),
        updateListId(list) {
            this.model.list_id = (list != null) ? list.id : null;
        },
        clearSelectedListId () {
            this.model.selectedListId = null;
            this.model.list_id        = null;
        },
        onProjectSettingSearch(search) {
            if (search == '') {
                this.currentProjectSetting = [];
                
                return false;
            }

            this.isProjectSettingLoading = true;
            this.searchProjectSetting(search, this);
        },
        searchProjectSetting: _.debounce((search, vm) => {
            let data = http.route('projectsetting?project_id='+vm.$route.params.id+'&get_all=1&search_select_key_and_value=' + search + '&filters[type]=weld_type').get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentProjectSetting = response.data;
                }
                vm.isProjectSettingLoading = false;
            });
        }, 500),
        updateProjectSetting(project_setting) {
            this.model.weld_type_id = (project_setting != null) ? project_setting.id : null;
        },
        clearSelectedProjectSetting () {
            this.model.selectedProjectSetting = null;
            this.model.weld_type_id           = null;
        },
        onWeldMaterialSearch(search) {
            if (search == '') {
                this.currentWeldMaterial = [];
                
                return false;
            }

            this.isWeldMaterialLoading = true;
            this.searchWeldMaterial(search, this);
        },
        searchWeldMaterial: _.debounce((search, vm) => {
            let data = http.route('projectsetting?project_id='+vm.$route.params.id+'&get_all=1&search_select=' + search + '&filters[type]=weld_material').get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentWeldMaterial = response.data;
                }
                vm.isWeldMaterialLoading = false;
            });
        }, 500),
        updateWeldMaterial(weld_material) {
            this.model.weld_material_id = (weld_material != null) ? weld_material.id : null;
        },
        clearSelectedWeldMaterial () {
            this.model.selectedWeldMaterial = null;
            this.model.weld_material_id     = null;
        },
	}
}
</script>

<style scoped>
    select {
        -webkit-appearance:menulist-button;
        -moz-appearance:menulist-button;
    }
</style>


// WEBPACK FOOTER //
// src/components/global/modals/CalculationModal.vue